import React from 'react';
import { connect } from 'react-redux';
import Link from '../lib/Link'
//import LazyImage from '../lib/LazyImage'
//import {Bg} from '../field'
import {claim, find, release} from '../reducers/page'
import renderers from './ViewRenderer'

const ViewRenderer = ({view, viewData, RowRenderer, lang}) => 
	<div className='view'>
		<div className='view-content'>
			{view.title && <h2 className='title'>{view.title}</h2>}
			{viewData.data.map((item, i) => 
				<RowRenderer key={i} index={i} view={view} entity={item} lang={lang}/>
			)}
		</div>
		{view.moreText && view.moreLink &&
			<Link to={view.moreLink} className='more-link'>{view.moreText}</Link>
		}
	</div>
	
class View extends React.Component {
	state = {
		id: null
	}

	componentWillMount() {
		const {claim, view} = this.props

		claim(view.id)
		this.setState({id: view.id},
			() => this.update())
	}
	
	componentWillUnmount() {
		const {release, view} = this.props

		release(view.id)
	}
	
	componentWillReceiveProps({view}) {
		const {release, claim} = this.props
		if(this.props.view.id!==view.id) {
			release(this.props.view.id)
			claim(view.id)
			this.setState({id: view.id},
				() => this.update())
		}
	}
	
	update = () => {
		const {id} = this.state
		const {find, view, lang} = this.props
		
		find(id, {
				collection: view.collection || 'node', 
				query: view.query,
				projection: view.projection,
				pageSize: view.pageSize,
				sort: view.sort,
				lang
			})
	}
	
	render() {
		const {view, viewData, lang} = this.props

		if (!viewData) return null
		
		const RowRenderer = (view.rowRenderer&&renderers[view.rowRenderer])
			?renderers[view.rowRenderer]:
			renderers['row']
		
		const Renderer = (view.viewRenderer&&renderers[view.viewRenderer])
			?renderers[view.viewRenderer]
			:ViewRenderer
		
		return <Renderer view={view} viewData={viewData} RowRenderer={RowRenderer} lang={lang}/>
		
/*		return (
		<div className='view'>
			<div className='view-content'>
				{view.title && <h2 className='title'>{view.title}</h2>}
				{viewData.data.map((item, i) => 
					<RowRenderer key={i} index={i} entity={item} lang={lang}/>
				)}
			</div>
			{view.moreText && view.moreLink &&
				<Link to={view.moreLink} className='more-link'>{view.moreText}</Link>
			}
		</div>
		)*/
	}
}
function mapStateToProps(state, ownProps) {
	return {
		lang: state.page.lang,
		viewData: state.page[ownProps.view.id]
	}
}
export default connect(mapStateToProps, {claim, find, release})(View);



// WEBPACK FOOTER //
// ./src/fm/block/View.js